module.exports = __webpack_public_path__ + "img/avatar-ask.9d31a201.png";